import { useEffect, useState } from "react";
import DynamicBreadcrumb from "../components/common/DynamicBreadcrumb";
import Seo from "../components/_App/seo";
import { fetchPageBySlug } from "../api/axios";
import ImageWithText from "../components/sections/ImageWithText";
import MissionList from "../components/sections/MissionList";
import ProjectStartArea from "../components/sections/ProjectStartArea";
import ServicesSection from "../components/sections/ServicesSection";
import WhoWeAre from "../components/About/WhoWeAre";
import StrategyRenderer from "../components/common/StrategyRenderer";
import VisionMission from "../components/About/VisionMission";
import OurLeadership from "../components/About/OurLeadership";
import OurGlobalPresence from "../components/common/OurGlobalPresence";
import Preloader from "../components/_App/Preloader";
const About = () => {
  const [pageData, setPageData] = useState(undefined);
  const componentMap = {
    "sections.image-with-text": ImageWithText,
    "sections.mission-list": MissionList,
    "sections.about-area-section": ProjectStartArea,
    "sections.solution-section": ServicesSection,
    "sections.cta-section": WhoWeAre,
    "sections.strategy-section": StrategyRenderer,
    "sections.stats-section": VisionMission,
    "sections.top-form-with-text": OurLeadership,
    "sections.core-commitments": OurGlobalPresence,
  };
  useEffect(() => {
    fetchPageBySlug("about-us").then((data) => {
      setPageData(data ?? null);
    });
  }, []);
  if (pageData === undefined) return <Preloader />;
  return (
    <>
      {pageData && (
        <Seo
          seo={pageData?.seo}
          slug={pageData?.slug}
        />
      )}
      <DynamicBreadcrumb />
      {pageData?.sections?.map((section) => {
        const SectionComponent = componentMap[section.__component];

        return SectionComponent ? (
          <SectionComponent key={section.id} data={section} />
        ) : null;
      })}
    </>
  )
}

export default About
